
Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal,
  objectEnumValues,
  makeStrictEnum,
  Public,
} = require('@prisma/client/runtime/index-browser')


const Prisma = {}

exports.Prisma = Prisma

/**
 * Prisma Client JS version: 4.16.2
 * Query Engine version: 2920a97877e12e055c1333079b8d19cee7f33826
 */
Prisma.prismaVersion = {
  client: "4.16.2",
  engine: "2920a97877e12e055c1333079b8d19cee7f33826"
}

Prisma.PrismaClientKnownRequestError = () => {
  throw new Error(`PrismaClientKnownRequestError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  throw new Error(`PrismaClientUnknownRequestError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientRustPanicError = () => {
  throw new Error(`PrismaClientRustPanicError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientInitializationError = () => {
  throw new Error(`PrismaClientInitializationError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientValidationError = () => {
  throw new Error(`PrismaClientValidationError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.NotFoundError = () => {
  throw new Error(`NotFoundError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  throw new Error(`sqltag is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.empty = () => {
  throw new Error(`empty is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.join = () => {
  throw new Error(`join is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.raw = () => {
  throw new Error(`raw is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.validator = Public.validator

/**
* Extensions
*/
Prisma.getExtensionContext = () => {
  throw new Error(`Extensions.getExtensionContext is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.defineExtension = () => {
  throw new Error(`Extensions.defineExtension is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}

/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = objectEnumValues.instances.DbNull
Prisma.JsonNull = objectEnumValues.instances.JsonNull
Prisma.AnyNull = objectEnumValues.instances.AnyNull

Prisma.NullTypes = {
  DbNull: objectEnumValues.classes.DbNull,
  JsonNull: objectEnumValues.classes.JsonNull,
  AnyNull: objectEnumValues.classes.AnyNull
}

/**
 * Enums
 */

exports.Prisma.TransactionIsolationLevel = makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
});

exports.Prisma.AccountScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  type: 'type',
  provider: 'provider',
  providerAccountId: 'providerAccountId',
  refresh_token: 'refresh_token',
  access_token: 'access_token',
  expires_at: 'expires_at',
  token_type: 'token_type',
  scope: 'scope',
  id_token: 'id_token',
  session_state: 'session_state'
};

exports.Prisma.SessionScalarFieldEnum = {
  id: 'id',
  sessionToken: 'sessionToken',
  userId: 'userId',
  expires: 'expires'
};

exports.Prisma.UserScalarFieldEnum = {
  id: 'id',
  name: 'name',
  email: 'email',
  emailVerified: 'emailVerified',
  verificationToken: 'verificationToken',
  passwordDigest: 'passwordDigest',
  image: 'image',
  resetToken: 'resetToken',
  tokenTimestamp: 'tokenTimestamp',
  isGuest: 'isGuest',
  isAdmin: 'isAdmin',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.VerificationTokenScalarFieldEnum = {
  identifier: 'identifier',
  token: 'token',
  expires: 'expires'
};

exports.Prisma.UserDataScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  firstName: 'firstName',
  lastName: 'lastName',
  profession: 'profession',
  heardFrom: 'heardFrom',
  accountProvider: 'accountProvider',
  isFirstTimer: 'isFirstTimer',
  notifications: 'notifications'
};

exports.Prisma.AccountIntegrationScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  provider: 'provider',
  accessToken: 'accessToken',
  refreshToken: 'refreshToken',
  accessTokenExpires: 'accessTokenExpires'
};

exports.Prisma.SubscriptionDataScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  stripeCustomerID: 'stripeCustomerID',
  subscriptionId: 'subscriptionId',
  nextBillingDate: 'nextBillingDate',
  isAnnual: 'isAnnual',
  referral: 'referral',
  activePlan: 'activePlan',
  nextPlan: 'nextPlan',
  initPlan: 'initPlan',
  startedCheckoutAt: 'startedCheckoutAt',
  cancelledAt: 'cancelledAt',
  upgradedAt: 'upgradedAt'
};

exports.Prisma.PlanSwitchScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  oldPlan: 'oldPlan',
  newPlan: 'newPlan',
  createdAt: 'createdAt'
};

exports.Prisma.SearchScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  status: 'status',
  searchType: 'searchType',
  title: 'title',
  keyword: 'keyword',
  url: 'url',
  language: 'language',
  country: 'country',
  mozDa: 'mozDa',
  mozPa: 'mozPa',
  googleInsight: 'googleInsight',
  spamScore: 'spamScore',
  authorityScore: 'authorityScore',
  domainsNum: 'domainsNum',
  accessToken: 'accessToken',
  difficulty: 'difficulty',
  totalLoadTime: 'totalLoadTime',
  word_count: 'word_count',
  flesch_reading_ease: 'flesch_reading_ease',
  readability: 'readability',
  hasBeenOpened: 'hasBeenOpened',
  isActive: 'isActive',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  periodStart: 'periodStart',
  periodEnd: 'periodEnd',
  topPositions: 'topPositions',
  firstDuration: 'firstDuration',
  duration: 'duration',
  excludedKeywords: 'excludedKeywords'
};

exports.Prisma.KeywordResultScalarFieldEnum = {
  id: 'id',
  searchId: 'searchId',
  isMainKeyword: 'isMainKeyword',
  keyword: 'keyword',
  competition: 'competition',
  volume: 'volume'
};

exports.Prisma.ExistingKeywordResultScalarFieldEnum = {
  id: 'id',
  searchId: 'searchId',
  status: 'status',
  keyword: 'keyword',
  pageUrl: 'pageUrl',
  position: 'position',
  positionOld: 'positionOld',
  clicks: 'clicks',
  impressions: 'impressions',
  ctr: 'ctr',
  hidden: 'hidden'
};

exports.Prisma.OrganicResultScalarFieldEnum = {
  id: 'id',
  resultId: 'resultId',
  existingResultId: 'existingResultId',
  isUserPage: 'isUserPage',
  title: 'title',
  url: 'url',
  authorityScore: 'authorityScore',
  totalLoadTime: 'totalLoadTime',
  lastUpdated: 'lastUpdated',
  missingWordsFromTitle: 'missingWordsFromTitle',
  wordCount: 'wordCount',
  readability: 'readability',
  rankingPlace: 'rankingPlace',
  domainsNum: 'domainsNum',
  pageType: 'pageType'
};

exports.Prisma.SuggestionSearchScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  url: 'url',
  status: 'status',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.SuggestionResultScalarFieldEnum = {
  id: 'id',
  suggestionSearchId: 'suggestionSearchId',
  topic: 'topic',
  isClicked: 'isClicked'
};

exports.Prisma.ExportScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  type: 'type',
  timestamp: 'timestamp'
};

exports.Prisma.UserMetricsScalarFieldEnum = {
  id: 'id',
  metricsData: 'metricsData',
  createdAt: 'createdAt'
};

exports.Prisma.SettingsScalarFieldEnum = {
  id: 'id',
  name: 'name',
  data: 'data',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ErrorsScalarFieldEnum = {
  id: 'id',
  code: 'code',
  body: 'body',
  createdAt: 'createdAt'
};

exports.Prisma.TitleIdeasScalarFieldEnum = {
  id: 'id',
  keyword: 'keyword',
  titles: 'titles',
  userId: 'userId',
  createdAt: 'createdAt',
  keywordResultId: 'keywordResultId'
};

exports.Prisma.ContentBriefScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  title: 'title',
  contentFocus: 'contentFocus',
  outline: 'outline',
  targetAudience: 'targetAudience',
  contentOverview: 'contentOverview',
  keyQuestions: 'keyQuestions',
  requiredKeywords: 'requiredKeywords',
  resources: 'resources',
  keywordName: 'keywordName',
  keywordResultId: 'keywordResultId',
  createdAt: 'createdAt'
};

exports.Prisma.ArticleGenieScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  createdAt: 'createdAt',
  title: 'title',
  content: 'content',
  keywordName: 'keywordName',
  keywordResultId: 'keywordResultId'
};

exports.Prisma.MetaDescriptionScalarFieldEnum = {
  id: 'id',
  keyword: 'keyword',
  content: 'content',
  userId: 'userId',
  createdAt: 'createdAt',
  keywordResultId: 'keywordResultId'
};

exports.Prisma.SortOrder = {
  asc: 'asc',
  desc: 'desc'
};

exports.Prisma.JsonNullValueInput = {
  JsonNull: Prisma.JsonNull
};

exports.Prisma.NullableJsonNullValueInput = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull
};

exports.Prisma.QueryMode = {
  default: 'default',
  insensitive: 'insensitive'
};

exports.Prisma.NullsOrder = {
  first: 'first',
  last: 'last'
};

exports.Prisma.JsonNullValueFilter = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull,
  AnyNull: Prisma.AnyNull
};
exports.AccountProviderType = {
  CREDENTIALS: 'CREDENTIALS',
  GOOGLE: 'GOOGLE'
};

exports.AccountIntegrationType = {
  GOOGLE: 'GOOGLE'
};

exports.SubscriptionType = {
  FREE: 'FREE',
  BASIC: 'BASIC',
  PREMIUM: 'PREMIUM',
  GOD: 'GOD',
  STARTER: 'STARTER'
};

exports.SearchStatus = {
  DONE: 'DONE',
  PENDING: 'PENDING',
  FAILED: 'FAILED',
  RUNNING: 'RUNNING',
  CANCELED: 'CANCELED'
};

exports.SearchType = {
  CREATE_NEW: 'CREATE_NEW',
  UPDATE_EXISTING: 'UPDATE_EXISTING'
};

exports.ExistingKeywordStatus = {
  DONE: 'DONE',
  PENDING: 'PENDING',
  FAILED: 'FAILED',
  RUNNING: 'RUNNING',
  NOT_STARTED: 'NOT_STARTED'
};

exports.PageType = {
  SOCIAL: 'SOCIAL',
  FORUM: 'FORUM',
  WEBSHOP: 'WEBSHOP'
};

exports.Prisma.ModelName = {
  Account: 'Account',
  Session: 'Session',
  User: 'User',
  VerificationToken: 'VerificationToken',
  UserData: 'UserData',
  AccountIntegration: 'AccountIntegration',
  SubscriptionData: 'SubscriptionData',
  PlanSwitch: 'PlanSwitch',
  Search: 'Search',
  KeywordResult: 'KeywordResult',
  ExistingKeywordResult: 'ExistingKeywordResult',
  OrganicResult: 'OrganicResult',
  SuggestionSearch: 'SuggestionSearch',
  SuggestionResult: 'SuggestionResult',
  Export: 'Export',
  UserMetrics: 'UserMetrics',
  Settings: 'Settings',
  Errors: 'Errors',
  TitleIdeas: 'TitleIdeas',
  ContentBrief: 'ContentBrief',
  ArticleGenie: 'ArticleGenie',
  MetaDescription: 'MetaDescription'
};

/**
 * Create the Client
 */
class PrismaClient {
  constructor() {
    throw new Error(
      `PrismaClient is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
    )
  }
}
exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
